/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserValidationError {
    EMAIL_ALREADY_IN_USE = 'EmailAlreadyInUse',
}
